/**
 * ═══════════════════════════════════════════════════════════════════
 * CONFIGURATEUR CHARMY PARIS — configurator.js
 * Fichier : assets/configurator.js
 *
 * Fonctionnement :
 * - Charge les charms via l'API Storefront (GraphQL) ou l'API REST
 * - Ajoute tous les items au panier via l'API AJAX Shopify (/cart/add.js)
 * - Compatible avec tous les thèmes Shopify 2.0
 * ═══════════════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────
  const C = window.CHARMY_CONFIG || {};
  const MAX_SLOTS = C.maxSlots || 17;
  const CURRENCY = C.currency || '€';
  const CHARM_PRICE_CENTS = 390; // fallback si non chargé

  // ─── ÉTAT ──────────────────────────────────────────────────────────
  const state = {
    step: 1,
    braceletVariantId: C.braceletVariantId || null,
    braceletPrice: C.braceletPrice || 0,        // en centimes Shopify
    selectedCharms: [],                          // [{variantId, title, price, image, handle}]
    allCharms: [],                               // catalogue complet
    filteredCharms: [],                          // après filtre actif
    currentCollection: 'all',
    searchQuery: '',
    packaging: { price: 0, title: 'Pochette velours', variantId: null },
    giftMessage: '',
  };

  // ─── SVG BRACELET ──────────────────────────────────────────────────
  const SVG_W = 560, SVG_H = 220;
  const SLOT_START_X = 68, SLOT_END_X = 502, SLOT_Y = 110;
  const SLOT_R = 22;

  function getSlotPositions(count) {
    const positions = [];
    for (let i = 0; i < count; i++) {
      positions.push({
        x: SLOT_START_X + (i * (SLOT_END_X - SLOT_START_X) / (count - 1)),
        y: SLOT_Y
      });
    }
    return positions;
  }

  function renderBraceletSVG() {
    const g = document.getElementById('cfg-slots-group');
    if (!g) return;
    g.innerHTML = '';

    const slots = Math.max(MAX_SLOTS, state.selectedCharms.length);
    const positions = getSlotPositions(slots);

    positions.forEach((pos, i) => {
      const charm = state.selectedCharms[i] || null;
      const ns = 'http://www.w3.org/2000/svg';

      const group = document.createElementNS(ns, 'g');
      group.style.cursor = 'pointer';
      group.setAttribute('role', 'button');
      group.setAttribute('aria-label', charm ? `Slot ${i+1}: ${charm.title}` : `Emplacement vide ${i+1}`);

      // Connecteur vertical (petit trait reliant la chaîne au charm)
      if (charm) {
        const line = document.createElementNS(ns, 'line');
        line.setAttribute('x1', pos.x); line.setAttribute('y1', pos.y - SLOT_R);
        line.setAttribute('x2', pos.x); line.setAttribute('y2', pos.y - SLOT_R - 6);
        line.setAttribute('stroke', '#C9A96E'); line.setAttribute('stroke-width', '1.5');
        group.appendChild(line);
      }

      // Cercle de base
      const circle = document.createElementNS(ns, 'circle');
      circle.setAttribute('cx', pos.x); circle.setAttribute('cy', pos.y);
      circle.setAttribute('r', SLOT_R);
      circle.setAttribute('fill', charm ? '#FDF6ED' : 'white');
      circle.setAttribute('stroke', charm ? '#C9A96E' : '#DDD4C8');
      circle.setAttribute('stroke-width', charm ? '2' : '1.2');
      group.appendChild(circle);

      if (charm) {
        // Image du charm si disponible, sinon initiale
        if (charm.image) {
          const img = document.createElementNS(ns, 'image');
          img.setAttribute('href', charm.image);
          img.setAttribute('x', pos.x - 16); img.setAttribute('y', pos.y - 16);
          img.setAttribute('width', '32'); img.setAttribute('height', '32');
          img.setAttribute('clip-path', `circle(${SLOT_R - 2}px at center)`);
          img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          group.appendChild(img);
        } else {
          const txt = document.createElementNS(ns, 'text');
          txt.setAttribute('x', pos.x); txt.setAttribute('y', pos.y + 1);
          txt.setAttribute('text-anchor', 'middle');
          txt.setAttribute('dominant-baseline', 'central');
          txt.setAttribute('font-size', '11');
          txt.setAttribute('fill', '#8B6B3D');
          txt.setAttribute('font-family', 'sans-serif');
          txt.textContent = charm.title.substring(0, 3).toUpperCase();
          group.appendChild(txt);
        }

        // Bouton supprimer (×)
        const delG = document.createElementNS(ns, 'g');
        delG.style.cursor = 'pointer';
        delG.onclick = (e) => { e.stopPropagation(); removeCharm(i); };

        const delCircle = document.createElementNS(ns, 'circle');
        delCircle.setAttribute('cx', pos.x + SLOT_R - 5);
        delCircle.setAttribute('cy', pos.y - SLOT_R + 5);
        delCircle.setAttribute('r', '8');
        delCircle.setAttribute('fill', '#C9A96E');
        delG.appendChild(delCircle);

        const delTxt = document.createElementNS(ns, 'text');
        delTxt.setAttribute('x', pos.x + SLOT_R - 5);
        delTxt.setAttribute('y', pos.y - SLOT_R + 6);
        delTxt.setAttribute('text-anchor', 'middle');
        delTxt.setAttribute('dominant-baseline', 'central');
        delTxt.setAttribute('font-size', '10');
        delTxt.setAttribute('fill', 'white');
        delTxt.setAttribute('font-weight', 'bold');
        delTxt.textContent = '×';
        delG.appendChild(delTxt);
        group.appendChild(delG);

      } else {
        // Slot vide : numéro
        const txt = document.createElementNS(ns, 'text');
        txt.setAttribute('x', pos.x); txt.setAttribute('y', pos.y + 1);
        txt.setAttribute('text-anchor', 'middle');
        txt.setAttribute('dominant-baseline', 'central');
        txt.setAttribute('font-size', '10');
        txt.setAttribute('fill', '#C5BEB5');
        txt.setAttribute('font-family', 'sans-serif');
        txt.textContent = i + 1;
        group.appendChild(txt);
      }

      // Click sur slot vide → aller à l'étape 2
      group.onclick = () => { if (!charm) CFG.goStep(2); };
      g.appendChild(group);
    });
  }

  // ─── CHARGEMENT CHARMS VIA STOREFRONT API ─────────────────────────
  async function loadCharms(collectionHandle) {
    const endpoint = `https://${C.shopDomain}/api/2024-01/graphql.json`;

    const query = `
      query CollectionCharms($handle: String!, $first: Int!) {
        collection(handle: $handle) {
          title
          products(first: $first, sortKey: BEST_SELLING) {
            edges {
              node {
                id
                title
                handle
                availableForSale
                priceRange { minVariantPrice { amount } }
                featuredImage { url(transform: { maxWidth: 120, maxHeight: 120, crop: CENTER }) }
                variants(first: 1) {
                  edges {
                    node {
                      id
                      availableForSale
                      price { amount }
                    }
                  }
                }
                collections(first: 5) {
                  edges { node { handle title } }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.CHARMY_STOREFRONT_TOKEN || ''
        },
        body: JSON.stringify({
          query,
          variables: { handle: collectionHandle, first: 250 }
        })
      });

      const data = await res.json();
      const products = data?.data?.collection?.products?.edges || [];

      return products
        .filter(e => e.node.availableForSale)
        .map(e => {
          const node = e.node;
          const variant = node.variants.edges[0]?.node;
          const priceAmount = parseFloat(variant?.price?.amount || node.priceRange.minVariantPrice.amount);
          const collections = node.collections.edges.map(c => c.node.handle);

          return {
            id: node.id,
            handle: node.handle,
            title: node.title,
            variantId: variant?.id || null,
            price: Math.round(priceAmount * 100), // en centimes
            priceDisplay: priceAmount.toFixed(2).replace('.', ',') + ' €',
            image: node.featuredImage?.url || null,
            available: variant?.availableForSale || false,
            collections: collections
          };
        });

    } catch (err) {
      console.error('[Charmy] Erreur chargement Storefront API:', err);
      // Fallback : charger via l'API REST publique
      return loadCharmsREST(collectionHandle);
    }
  }

  // Fallback via API REST (pas besoin de token)
  async function loadCharmsREST(collectionHandle) {
    try {
      const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250&sort_by=best-selling`);
      const data = await res.json();
      return (data.products || []).map(p => {
        const variant = p.variants?.[0];
        const price = Math.round(parseFloat(variant?.price || '0') * 100);
        return {
          id: 'gid://shopify/Product/' + p.id,
          handle: p.handle,
          title: p.title,
          variantId: variant?.id ? String(variant.id) : null,
          price: price,
          priceDisplay: parseFloat(variant?.price || 0).toFixed(2).replace('.', ',') + ' €',
          image: p.images?.[0]?.src || null,
          available: variant?.available !== false,
          collections: []
        };
      }).filter(c => c.available);
    } catch (err) {
      console.error('[Charmy] Erreur REST fallback:', err);
      return [];
    }
  }

  // ─── RENDU GRILLE CHARMS ──────────────────────────────────────────
  function renderCharmGrid(charms) {
    const grid = document.getElementById('cfg-charms-grid');
    if (!grid) return;

    if (charms.length === 0) {
      grid.innerHTML = `<div class="cfg-empty">
        <p>Aucun charm trouvé pour cette recherche.</p>
        <button class="cfg-btn cfg-btn--ghost" onclick="CFG.filterCol(document.querySelector('.cfg-filter'),'all')">
          Voir tous les charms
        </button>
      </div>`;
      return;
    }

    grid.innerHTML = charms.map(charm => {
      const addedCount = state.selectedCharms.filter(c => c.variantId === charm.variantId).length;
      const isAdded = addedCount > 0;

      return `
        <div class="cfg-charm-card ${isAdded ? 'cfg-charm-card--added' : ''} ${!charm.available ? 'cfg-charm-card--oos' : ''}"
             onclick="${charm.available ? `CFG.addCharm(${JSON.stringify(charm).replace(/"/g, '&quot;')})` : ''}"
             role="button"
             tabindex="${charm.available ? 0 : -1}"
             aria-label="${charm.title}${isAdded ? ' — dans ton bracelet' : ''}"
             onkeydown="if(event.key==='Enter'||event.key===' ')this.click()">
          ${isAdded ? `<span class="cfg-charm-badge">${addedCount}</span>` : ''}
          <div class="cfg-charm-card__img-wrap">
            ${charm.image 
              ? `<img src="${charm.image}" alt="${charm.title}" loading="lazy">`
              : `<div class="cfg-charm-card__placeholder">${charm.title.slice(0,2).toUpperCase()}</div>`
            }
          </div>
          <div class="cfg-charm-card__name">${charm.title}</div>
          <div class="cfg-charm-card__price">${charm.priceDisplay}</div>
          ${!charm.available ? '<div class="cfg-charm-card__oos">Épuisé</div>' : ''}
          ${charm.available ? `<button class="cfg-charm-card__add" aria-label="Ajouter ${charm.title}" tabindex="-1">
            ${isAdded ? '✓' : '+'}
          </button>` : ''}
        </div>
      `;
    }).join('');
  }

  // ─── CHIPS RÉSUMÉ ─────────────────────────────────────────────────
  function renderChips() {
    const wrap = document.getElementById('cfg-selected-chips');
    if (!wrap) return;

    if (state.selectedCharms.length === 0) {
      wrap.innerHTML = '<p class="cfg-chips__empty">Aucun charm sélectionné pour l\'instant</p>';
      return;
    }

    wrap.innerHTML = state.selectedCharms.map((charm, i) => `
      <span class="cfg-chip">
        ${charm.image ? `<img src="${charm.image}" alt="${charm.title}" width="20" height="20">` : ''}
        ${charm.title}
        <button onclick="CFG.removeCharm(${i})" aria-label="Retirer ${charm.title}">×</button>
      </span>
    `).join('');
  }

  // ─── RÉCAP ÉTAPE 3 ────────────────────────────────────────────────
  function renderRecap() {
    const list = document.getElementById('cfg-recap-list');
    if (!list) return;

    const braceletPriceFormatted = formatPrice(state.braceletPrice);
    const items = [
      { title: 'Bracelet Or', price: state.braceletPrice, image: null }
    ];

    // Regrouper les charms identiques
    const charmMap = {};
    state.selectedCharms.forEach(c => {
      if (charmMap[c.variantId]) {
        charmMap[c.variantId].qty++;
      } else {
        charmMap[c.variantId] = { ...c, qty: 1 };
      }
    });

    const charmItems = Object.values(charmMap);

    list.innerHTML = `
      <div class="cfg-recap__item">
        <span class="cfg-recap__name">Bracelet de base</span>
        <span class="cfg-recap__price">${braceletPriceFormatted}</span>
      </div>
      ${charmItems.map(c => `
        <div class="cfg-recap__item">
          ${c.image ? `<img src="${c.image}" width="32" height="32" alt="${c.title}" class="cfg-recap__img">` : ''}
          <span class="cfg-recap__name">
            ${c.title}
            ${c.qty > 1 ? `<span class="cfg-recap__qty">× ${c.qty}</span>` : ''}
          </span>
          <span class="cfg-recap__price">${formatPrice(c.price * c.qty)}</span>
        </div>
      `).join('')}
      ${state.packaging.price > 0 ? `
        <div class="cfg-recap__item">
          <span class="cfg-recap__name">${state.packaging.title}</span>
          <span class="cfg-recap__price">+ ${formatPrice(state.packaging.price)}</span>
        </div>
      ` : ''}
    `;

    // Codes promo actifs
    const promoEl = document.getElementById('cfg-promo-active');
    if (promoEl) {
      const count = state.selectedCharms.length;
      let html = '';
      if (count >= C.promoThresholds?.charm10) {
        html = `<div class="cfg-promo-active cfg-promo-active--gold">🎀 Code <strong>CHARMY10</strong> — 1 bracelet offert !</div>`;
      } else if (count >= C.promoThresholds?.charm5) {
        html = `<div class="cfg-promo-active">🎁 Code <strong>CHARMY5</strong> — 1 charm offert !</div>`;
      }
      promoEl.innerHTML = html;
    }
  }

  // ─── MISE À JOUR PRIX & UI ────────────────────────────────────────
  function updateUI() {
    const charmTotal = state.selectedCharms.reduce((s, c) => s + c.price, 0);
    const total = state.braceletPrice + charmTotal + state.packaging.price;
    const count = state.selectedCharms.length;

    // Prix total preview
    const priceEl = document.getElementById('cfg-total-price');
    if (priceEl) priceEl.textContent = formatPrice(total);

    // Bouton panier
    const cartPrice = document.getElementById('cfg-cart-price');
    if (cartPrice) cartPrice.textContent = formatPrice(total);

    const cartLabel = document.getElementById('cfg-cart-label');
    if (cartLabel) {
      cartLabel.textContent = count > 0
        ? `Ajouter au panier (${count} charm${count > 1 ? 's' : ''})`
        : 'Ajouter au panier';
    }

    // Slots
    const slotsEl = document.getElementById('cfg-slots-count');
    if (slotsEl) slotsEl.textContent = `${count} / ${MAX_SLOTS} emplacements`;

    const slotsLeft = document.getElementById('cfg-slots-left');
    if (slotsLeft) slotsLeft.textContent = `${MAX_SLOTS - count} emplacements disponibles`;

    const charmCount = document.getElementById('cfg-charm-count');
    if (charmCount) charmCount.textContent = count;

    // Hint panier
    const hint = document.getElementById('cfg-cart-hint');
    if (hint) {
      if (total >= 5000) {
        hint.textContent = `✓ Livraison offerte · Montage en atelier inclus`;
        hint.style.color = '#2a7a4f';
      } else {
        const remaining = formatPrice(5000 - total);
        hint.textContent = `Plus que ${remaining} pour la livraison offerte`;
        hint.style.color = '';
      }
    }

    // Barre promo
    const promoFill = document.getElementById('cfg-promo-fill');
    const promoText = document.getElementById('cfg-promo-text');
    if (promoFill && promoText) {
      if (count < 5) {
        const pct = Math.round((count / 5) * 100);
        promoFill.style.width = pct + '%';
        promoText.textContent = `Plus que ${5 - count} charm(s) pour en recevoir 1 offert ! 🎁`;
      } else if (count < 10) {
        const pct = Math.round(((count - 5) / 5) * 100);
        promoFill.style.width = pct + '%';
        promoFill.style.background = '#C9A96E';
        promoText.textContent = `Code CHARMY5 activé 🎁 · Plus que ${10 - count} charm(s) pour un bracelet offert !`;
      } else {
        promoFill.style.width = '100%';
        promoFill.style.background = '#8B6B3D';
        promoText.textContent = `Code CHARMY10 activé 🎀 Un bracelet vous sera offert !`;
      }
    }

    // Total final étape 3
    const finalTotal = document.getElementById('cfg-final-total');
    if (finalTotal) finalTotal.textContent = formatPrice(total);

    renderBraceletSVG();
    renderChips();
    renderCharmGrid(state.filteredCharms);
    renderRecap();
  }

  // ─── FORMAT PRIX ─────────────────────────────────────────────────
  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + CURRENCY;
  }

  // ─── ACTIONS CHARMS ──────────────────────────────────────────────
  function addCharm(charm) {
    if (state.selectedCharms.length >= MAX_SLOTS) {
      showToast(`Bracelet complet ! (${MAX_SLOTS} charms maximum). Retire un charm pour en ajouter un autre.`, 'warning');
      return;
    }
    state.selectedCharms.push(charm);
    updateUI();
    showToast(`✓ ${charm.title} ajouté à ton bracelet`);
  }

  function removeCharm(index) {
    const removed = state.selectedCharms.splice(index, 1)[0];
    updateUI();
    if (removed) showToast(`${removed.title} retiré`);
  }

  // ─── NAVIGATION ÉTAPES ───────────────────────────────────────────
  function goStep(n) {
    state.step = n;

    document.querySelectorAll('.cfg-content').forEach((el, i) => {
      el.classList.toggle('cfg-content--hidden', i + 1 !== n);
    });

    document.querySelectorAll('.cfg-step').forEach((el, i) => {
      const active = i + 1 === n;
      el.classList.toggle('cfg-step--active', active);
      el.setAttribute('aria-selected', active);
    });

    // Scroll haut du panneau
    const panel = document.querySelector('.cfg-panel');
    if (panel) panel.scrollTop = 0;

    // Charger les charms au premier accès à l'étape 2
    if (n === 2 && state.allCharms.length === 0) {
      loadAndRenderCharms();
    }

    if (n === 3) renderRecap();
  }

  // ─── CHARGER ET AFFICHER CHARMS ──────────────────────────────────
  async function loadAndRenderCharms() {
    const handle = C.charmsCollectionHandle || 'tout-voir';
    const grid = document.getElementById('cfg-charms-grid');
    if (grid) grid.innerHTML = `<div class="cfg-loading"><div class="cfg-spinner"></div><p>Chargement des charms...</p></div>`;

    state.allCharms = await loadCharms(handle);
    state.filteredCharms = [...state.allCharms];
    renderCharmGrid(state.filteredCharms);
  }

  // ─── FILTRE COLLECTION ───────────────────────────────────────────
  function filterCol(btn, handle) {
    document.querySelectorAll('.cfg-filter').forEach(b => b.classList.remove('cfg-filter--active'));
    if (btn) btn.classList.add('cfg-filter--active');

    state.currentCollection = handle;
    applyFilters();
  }

  function searchCharms(query) {
    state.searchQuery = query.toLowerCase().trim();
    applyFilters();
  }

  function applyFilters() {
    let result = [...state.allCharms];

    if (state.currentCollection !== 'all') {
      result = result.filter(c => c.collections.includes(state.currentCollection));
      // Si la Storefront API ne retourne pas les collections, fallback recherche
      if (result.length === 0 && state.allCharms.length > 0) {
        // Charger la collection spécifique
        loadCharmsForCollection(state.currentCollection);
        return;
      }
    }

    if (state.searchQuery) {
      result = result.filter(c => c.title.toLowerCase().includes(state.searchQuery));
    }

    state.filteredCharms = result;
    renderCharmGrid(result);
  }

  async function loadCharmsForCollection(handle) {
    const grid = document.getElementById('cfg-charms-grid');
    if (grid) grid.innerHTML = `<div class="cfg-loading"><div class="cfg-spinner"></div><p>Chargement...</p></div>`;

    const charms = await loadCharmsREST(handle);
    state.filteredCharms = charms;
    renderCharmGrid(charms);
  }

  // ─── VARIANTE BRACELET ───────────────────────────────────────────
  function selectVariant(btn) {
    document.querySelectorAll('.cfg-size').forEach(b => b.classList.remove('cfg-size--active'));
    btn.classList.add('cfg-size--active');
    state.braceletVariantId = btn.dataset.variantId;
    state.braceletPrice = parseInt(btn.dataset.variantPrice || C.braceletPrice, 10);
    updateUI();
  }

  // ─── EMBALLAGE ───────────────────────────────────────────────────
  function setPackaging(price, title, variantId) {
    state.packaging = { price: parseInt(price, 10) || 0, title, variantId: variantId || null };
    updateUI();
  }

  // ─── AJOUTER AU PANIER SHOPIFY ───────────────────────────────────
  async function addToCart() {
    if (state.selectedCharms.length === 0 && !confirm('Tu n\'as pas encore ajouté de charm. Ajouter uniquement le bracelet ?')) return;

    const btn = document.getElementById('cfg-cart-btn');
    if (btn) { btn.disabled = true; btn.classList.add('cfg-btn--loading'); }

    const giftMsg = document.getElementById('cfg-gift-msg')?.value || '';

    // Construire les line items
    const items = [];

    // 1. Bracelet
    items.push({
      id: parseInt(state.braceletVariantId, 10),
      quantity: 1,
      properties: {
        '_configurateur': 'charmy-paris',
        'Message cadeau': giftMsg || undefined
      }
    });

    // 2. Charms
    const charmGroups = {};
    state.selectedCharms.forEach(c => {
      const vid = parseInt(c.variantId, 10);
      if (charmGroups[vid]) charmGroups[vid].quantity++;
      else charmGroups[vid] = {
        id: vid,
        quantity: 1,
        properties: { '_configurateur': 'charmy-paris' }
      };
    });
    items.push(...Object.values(charmGroups));

    // 3. Emballage premium
    if (state.packaging.variantId) {
      items.push({
        id: parseInt(state.packaging.variantId, 10),
        quantity: 1,
        properties: { '_configurateur': 'charmy-paris' }
      });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.description || 'Erreur panier');

      showToast('✓ Bracelet ajouté au panier ! Redirection...', 'success');

      // Mettre à jour le compteur panier du thème
      updateThemeCartCount();

      setTimeout(() => {
        window.location.href = C.cartUrl || '/cart';
      }, 1200);

    } catch (err) {
      console.error('[Charmy] Erreur ajout panier:', err);
      showToast('Une erreur est survenue. Réessaie ou rafraîchis la page.', 'error');
      if (btn) { btn.disabled = false; btn.classList.remove('cfg-btn--loading'); }
    }
  }

  // Mettre à jour le badge panier du thème Shopify
  async function updateThemeCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      // Déclencher un événement pour que le thème mette à jour son compteur
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      // Compatibilité Dawn et thèmes populaires
      const countEls = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
      countEls.forEach(el => el.textContent = cart.item_count);
    } catch {}
  }

  // ─── TOAST ───────────────────────────────────────────────────────
  let toastTimer;
  function showToast(msg, type = 'info') {
    const toast = document.getElementById('cfg-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.className = `cfg-toast cfg-toast--${type} cfg-toast--show`;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('cfg-toast--show'), 3500);
  }

  // ─── INIT ────────────────────────────────────────────────────────
  function init() {
    if (!document.getElementById('charmy-configurator')) return;
    updateUI();

    // Message cadeau
    const msgEl = document.getElementById('cfg-gift-msg');
    if (msgEl) msgEl.addEventListener('input', e => { state.giftMessage = e.target.value; });

    console.log('[Charmy Configurateur] Initialisé ✓');
  }

  // ─── API PUBLIQUE ────────────────────────────────────────────────
  window.CFG = {
    goStep,
    addCharm,
    removeCharm,
    filterCol,
    searchCharms,
    selectVariant,
    setPackaging,
    addToCart,
    state
  };

  // Exposer removeCharm globalement pour les callbacks SVG inline
  window.removeCharm = removeCharm;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
